import { Modal } from './Modal';

interface ConfirmProps {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  danger?: boolean;
  /** Deshabilita «Confirmar» mientras la acción está en curso. */
  disabled?: boolean;
}

export function Confirm({ open, title, message, onConfirm, onCancel, confirmLabel = 'Confirmar', danger = false, disabled = false }: ConfirmProps) {
  return (
    <Modal open={open} onClose={onCancel} title={title} size="sm">
      <div className="space-y-4">
        <p className="text-sm text-slate-600 whitespace-pre-line">{message}</p>
        <div className="flex justify-end gap-3 pt-4 border-t">
          <button onClick={onCancel} className="px-4 py-2 text-sm text-slate-600 hover:text-slate-800">Cancelar</button>
          <button onClick={onConfirm} disabled={disabled} className={`px-4 py-2 rounded-lg text-sm font-medium text-white disabled:opacity-50 ${danger ? 'bg-red-600 hover:bg-red-500' : 'bg-brand-600 hover:bg-brand-500'}`}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
